var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['dh-psy-diary', 'article-feature', {
    'dh-psy-diary--left': _vm.align === 'left',
    'dh-psy-diary--right': _vm.align === 'right'
  }]},[_c('div',{staticClass:"dh-psy-diaryWrapper"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('p',{staticClass:"dh-psy-diary__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._v(" "),_c('p',[_c('span',[_vm._v("\n        "+_vm._s(_vm.content)+"\n      ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }